import { useState } from "react";
import { AccordionProps } from "./Accordion.type";
import { ChevronDown } from "lucide-react";
import { cn } from "../../../../lib/utils";

export const AccordionV2: React.FC<AccordionProps> = ({
    className,
    header,
    headerClassName,
    footerSlot,
    contentClassName,
    children,
    showFooterDivider = false,
    showFooter = false,
    expanded = false,
    onDropStateChange
}) => {
    const [isExpanded, setIsExpanded] = useState(expanded);

    const handleToggle = () => {
        const newState = !isExpanded;
        setIsExpanded(newState);
        if(onDropStateChange && typeof onDropStateChange === 'function') {
            onDropStateChange(newState);
        }
    }

    return (
        <div className={cn("border border-gray-100 rounded-md shadow-overviewCard", className)}>
            <div className={cn("flex justify-between items-center px-4 py-3 bg-gray-50 rounded-inherit", headerClassName)} onClick={handleToggle}>
                <div onClick={e => e.stopPropagation()}>{header.title}</div>
                {header.centerSlot}
                <div className="flex items-center space-x-2 self-center">
                    {header.rightSlot && (
                        <div onClick={e => e.stopPropagation()}>{header.rightSlot}</div>
                    )}
                    {header.showArrowIcon && (
                        <button
                            onClick={handleToggle}
                            className={`p-2 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100 transform transition-transform duration-200 ease-in-out ${isExpanded ? 'rotate-180' : ''}`}
                            aria-expanded={isExpanded}
                            aria-label={isExpanded ? 'Collapse' : 'Expand'}
                        >
                            <ChevronDown width={16} height={16} color="#0A0A0A" />
                        </button>
                    )}
                </div>
            </div>
            {isExpanded && (
                <div className={cn("p-2 border-t border-gray-100", contentClassName)}>
                    {children}
                </div>
            )}
            {showFooter && (
                <div className={`p-2 border-t border-gray-100 ${showFooterDivider ? 'border-t' : ''}`}>
                    {footerSlot}
                </div>
            )}
        </div>
    );
}